import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a59e47ec"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-arrow-left" }, null, -1))
const _hoisted_2 = { class: "ml-1 text-bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createBlock(_component_Button, {
    class: "p-button-text p-button-primary",
    type: "button",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goBack()))
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.label), 1)
    ]),
    _: 1
  }))
}